import React from "react";
import { notification } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify"

import Person from "@parts/person";
import IndividualOrCompanySelect from "@parts/person/individualOrCopanySelect";
import Address from "@parts/address-component";

import StateRegistry from '../personAdaptToCompany/stateRegistry'

import { setPersonType } from "@parts/person/actions";
import {
  personValidate,
  addressValidate,
  valideteDocument,
  validateCompany
} from "@parts/person/utils";
import { setLoading } from "@inspinia-react/actions";

import PersonAdaptToCompany from "@parts/person/personAdaptToCompany";

import { api, getBranchOwner, post, put } from "@config";
import { mapTest } from "../../../pages/products/map.test";
import MunicipalRegistry from "../personAdaptToCompany/municipalRegistry";

class PersonAdaptToClient extends React.Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
  }

  showErros(errors) {
    notification.close(811);
    let errorsMsg = [];
    errors.forEach((err) => {
      errorsMsg.push(
        <li className="list-group-item py-0 my-0 mb-1">{`${err}`}</li>
      );
    });
    notification.open({
      type: "error",
      message: "Ops..",
      description: <ul className="list-group">{errorsMsg}</ul>,
      key: 811,
    });
  }

  save() {
    const { postalCode, stateLocation, cityLocation, street } = this.props
    if (!postalCode || !stateLocation || !cityLocation || !street) {
      window.scrollTo({ top: 0 })
      toast.error("Enderço não é válido", { toastId: "error-create-cliente-without-address" })
      return
    }
    const {
      type,
      doc,
      fancyName: fancy_name,
      stateRegistry: state_registry,
      municipalRegistry: municipal_registry,
      crt,
      ieIndicator, 
    } = this.props;
    const personErrors = personValidate(this.props);
    const docErrors = valideteDocument(this.props);
    const valideAddress = addressValidate(this.props, false);

    if (docErrors.length) {
      this.showErros(docErrors);
      return;
    }
    if (personErrors.errors.length > 0) {
      this.showErros(personErrors.errors);
      return;
    }

    if ([1, 2].includes(type)) {
      const companyErrors = validateCompany(this.props)
      if (companyErrors.length) {
        this.showErros(companyErrors);
        return;
      }
    }

    if (valideAddress.errors.length > 0) {
      this.showErros(valideAddress.errors);
      return;
    }

    const data = {
      ...personErrors.data,
      ...valideAddress,
    };

    if ([0, 3].includes(type)) {
      data.individual = { cpf: doc };

      if (state_registry) {
        data.individual.state_registry = state_registry;
      }
      if (municipal_registry) {
        data.individual.municipal_registry = municipal_registry;
      }


    } else {
      data.company = {
        cnpj: doc,
        fancy_name,
        state_registry,
        municipal_registry
      };
      if (ieIndicator) {
        data.company.ie_indicator = ieIndicator; 
      }
    }

    if ([0].includes(type)) {
      data.individual = { cpf: doc };

    }

    if (this.props.createBranch || this.props.updateBranch) {
      data.branch = {
        crt: crt || 1,
        is_fiscal: true,
        main_company: false,
        aliquota_credito: 1,
        branch_type: type + 1
      }
      this.props.createBranch ? this.props.createBranch(data) : this.props.updateBranch(data)
      return
    }

    this.props.setLoading(true);

    const payloadSave = (client) => {
      notification.open({
        type: "success",
        message: (
          <p>
            <strong>{client.name}</strong> cadastrado
          </p>
        ),
        description: "o cliente foi cadastrado com sucesso!",
      });
      setTimeout(() => {
        this.props.onSaveClient();
      }, 1500);
    };
    const payloadUpdate = (client) => {
      notification.open({
        type: "success",
        message: (
          <p>
            <strong>{client.name}</strong> atualizado
          </p>
        ),
        description: "o cliente foi atualizado com sucesso!",
      });
      setTimeout(() => {
        this.props.onSaveClient();
      }, 1500);
    };

    const errPayload = err => {
      this.props.setLoading(false)
      let errs = []
      if (err.response) {
        let response = JSON.parse(err.response)
        if (response.non_field_errors) {
          if (response.non_field_errors.includes("CNPJ Already registred")) {
            errs.push("CNPJ já Cadastrado")
          }
          if (response.non_field_errors.includes("CPF Already registred")) {
            errs.push("CPF já Cadastrado")
          }
        }
      }
      if (errs.length) {
        notification.open({
          message: "Erro!",
          type: "error",
          description: <ul>{errs.map(e => <li>{e}</li>)}</ul>,
          duration: 3,
          key: 55
        })
      }
    }

    if (this.props.clientId) {
      this._updateClient(data, payloadUpdate, errPayload);
    } else {
      this._saveClient(data, payloadSave, errPayload);
    }
  }

  _saveClient(data, payload, errPayload) {
    const branch_owner = getBranchOwner().id;
    const url = `${api.clients}?branch_owner=${branch_owner}`;
    post(url, data, payload, errPayload);
  }

  _updateClient(data, payload, errPayload) {
    const { clientId } = this.props;
    const branch_owner = getBranchOwner().id;
    const url = `${api.clients}${clientId}/?branch_owner=${branch_owner}`;

    put(url, data, payload, errPayload);
  }

  UNSAFE_componentWillMount() {
    this.props.setPersonType(0);
  }

  render() {
    const { type, hiddenSelectType } = this.props;
    return (
      <div className="pb-5 mb-5">
        <div className="py-2">
          <h3>Dados do cliente</h3>
          <div className={`row ${hiddenSelectType ? "d-none" : ""}`}>
            <div className="col-md-4 col-xs-12 py-2">
              <IndividualOrCompanySelect mei={this.props.mei} />
            </div>
          </div>
          <div className="row">
            <div className={`col-md-12 col-12`}>
              <Person />
            </div>
            {type === 1 || type === 2 ? (
              <div className="col-12 pt-sm-2 pt-lg-0">
                <PersonAdaptToCompany crt={Boolean(this.props.createBranch) || this.props.crt} />
              </div>
            ) : <div />}

            {type === 3 ? [
              <StateRegistry key='doc_state_registry' />,
              <div key='doc_municipal_registry' className="col-lg-6 col-sm-12">
                <MunicipalRegistry />
              </div>
            ] : <div />}

          </div>
        </div>
        <div className="py-2">
          <h3>Endereço do cliente</h3>
          <Address />
        </div>

        <div className="row">
          <button
            id={mapTest.createClient.saveButton}
            className={`btn btn-primary d-lg-none d-xl-none col-lg-4 my-3`}
            onClick={this.save}
          >
            Salvar Cliente
          </button>
          <button
            className="btn col-lg-4 col-sm-12  btn-danger"
            onClick={() => history.back()}
          >
            Cancelar
          </button>
          <div className='col-lg-4 col-sm-12  d-none d-lg-block .d-xl-block' />
          <button
            className={`btn btn-primary d-none d-lg-block .d-xl-block col-lg-4`}
            onClick={this.save}
          >
            Salvar Cliente
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  //person
  name: state.basePersonName,
  email: state.basePersonEmail,
  phone_number: state.basePersonPhone,

  //company
  fancyName: state.fancyName,
  stateRegistry: state.stateRegistry,
  municipalRegistry: state.municipalRegistry,
  crt: state.crt,
  ieIndicator: state.ieIndicator, 

  //address
  cityLocation: state.cityLocation,
  complement: state.complement,
  district: state.district,
  postalCode: state.postalCode,
  stateLocation: state.stateLocation,
  streetNumber: state.streetNumber,
  street: state.street,
  type: state.personType,
  doc: state.personDoc,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setPersonType, setLoading }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonAdaptToClient);



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToClient/index.jsx